import { startCase } from 'lodash';
import { ChipColor } from '@/components/chip/helpers';
import { AuditLogActions, AuditLogActor, AuditLogMeta } from '.';
import { JsonObject } from '../../helpers';
import { BaseModel } from '../base.model';

export class AuditLogModel extends BaseModel {
  orgId: string;
  eventType: string;
  eventCategory: string;
  eventAction: string;
  message: string;
  resourceId: string;
  resourceName: string;
  actor: AuditLogActor;
  eventDateTime: string;
  receivedDateTime: string;

  constructor(props: JsonObject = {}) {
    super(props);

    const data = props as Record<keyof AuditLogModel, unknown>;

    this.orgId = (data.orgId as string) || '';
    this.eventDateTime = (data.eventDateTime as string) || '';
    this.receivedDateTime = (data.receivedDateTime as string) || '';
    this.eventType = (data.eventType as string) || '';
    this.eventCategory = (data.eventCategory as string) || 'audit';
    this.eventAction = (data.eventAction as string) || '';
    this.message = (data.message as string) || '';
    this.resourceId = (data.resourceId as string) || '';
    this.resourceName = (data.resourceName as string) || '';
    this.actor = (data.actor as AuditLogActor) || { userId: '', orgId: '', name: '', email: '' };
  }

  get meta(): AuditLogMeta {
    return {
      id: this.id,
      eventDateTime: this.eventDateTime,
      eventType: this.eventType,
      name: this.resourceName,
    };
  }

  // Remove MongoDB ObjectIds in parentheses like the OrgId
  get cleanMessage(): string {
    return this.message.replace(/\s*\([a-f0-9]{24}\)/gi, '');
  }

  get resourceLabel(): string {
    return this.resourceName || this.resourceId;
  }

  get actionLabel(): string {
    return startCase(AuditLogActions.get(this.eventAction)?.label || this.eventAction);
  }

  get actionColor(): ChipColor | undefined {
    return AuditLogActions.get(this.eventAction)?.color;
  }
}
